/**
 * Precio mínimo aceptado para una propiedad.
 */
export const MIN_PROPERTY_PRICE = 100;

export const MIN_PROPERTY_PRICE_MESSAGE = `El precio debe ser de al menos $${MIN_PROPERTY_PRICE}`;

/**
 * Valida que un precio sea un número finito mayor o igual a `MIN_PROPERTY_PRICE`.
 *
 * Se usa como `.test` sobre un `Yup.string()` porque el valor viene de
 * `NumericFormat` (`floatValue`: número o `undefined`) y Yup lo castea a string
 * antes de correr el test. Comparar numéricamente evita que valores como `-99`,
 * `1.23` o `0.01` pasen sólo por tener 3 o más caracteres.
 */
export default function validateMinPrice(val) {
  if (val === undefined || val === null || val === "") return false;

  const price = Number(val);

  return Number.isFinite(price) && price >= MIN_PROPERTY_PRICE;
}
